import React from 'react'
import { Helmet } from 'react-helmet-async'
import { SubscriptionsLayout } from '../../layouts/Billing'

const SubscriptionsPage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Subscription details</title>
      <meta name="description" content="Subscription details page" />
    </Helmet>
    <SubscriptionsLayout />
  </React.Fragment>
)

export default SubscriptionsPage
